const messages = [
  {
    id: 1,
    name: 'Ayşe H.',
    location: 'Ankara → Frankfurt',
    time: '14:32',
    date: 'Dün',
    text: 'Serkan bey eşyalarım hasarsız geldi, çok teşekkür ederim! Paketleme çok özenli yapılmıştı, hiçbir şey kırılmamış. Kesinlikle tekrar kullanacağım 🙏',
    stars: 5,
  },
  {
    id: 2,
    name: 'Emre K.',
    location: 'İstanbul → München',
    time: '09:15',
    date: '3 gün önce',
    text: 'Hocam tam zamanında teslim ettiniz, süper! Almanya\'ya taşınmak çok stresli bir süreçti ama siz her adımda bilgilendirdiniz. Arkadaşlarıma da tavsiye edeceğim.',
    stars: 5,
  },
  {
    id: 3,
    name: 'Fatma Ş.',
    location: 'Bursa → Berlin',
    time: '18:47',
    date: '1 hafta önce',
    text: 'Allah razı olsun, çok memnun kaldım. Fiyat teklifini hemen verdiniz, süreç boyunca hiç sormak zorunda kalmadım çünkü siz zaten haber verdiniz. Harika hizmet!',
    stars: 5,
  },
  {
    id: 4,
    name: 'Murat D.',
    location: 'İzmir → Köln',
    time: '11:20',
    date: '2 hafta önce',
    text: 'Parsiyel gönderi yaptım, 3 koli. Tam 6 günde kapıma geldi. Fiyat da çok uygundu diğer firmalarla kıyasladım. Bir daha ihtiyacım olursa kesinlikle sizi arayacağım.',
    stars: 5,
  },
  {
    id: 5,
    name: 'Zeynep A.',
    location: 'Konya → Stuttgart',
    time: '20:03',
    date: '3 hafta önce',
    text: 'Çok profesyonel bir ekip. Eşyalarımı paketlerken bile fotoğraf çekip gönderdiler, içim rahat etti. Almanya\'ya taşınmak isteyenlere şiddetle tavsiye ederim 👍',
    stars: 5,
  },
  {
    id: 6,
    name: 'Hasan Y.',
    location: 'Adana → Hamburg',
    time: '16:55',
    date: '1 ay önce',
    text: 'Yıllardır farklı firmalar denedim ama Töle Lojistik\'i bulduktan sonra başkasına gerek kalmadı. Güvenilir, hızlı ve fiyatı makul. Teşekkürler!',
    stars: 5,
  },
];

export default function WhatsAppMessages() {
  return (
    <section className="py-20 bg-gray-50/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">WhatsApp Yorumları</p>
          <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-3">
            Müşterilerimizden Gelen Mesajlar
          </h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto">
            Gerçek müşterilerimizin WhatsApp üzerinden paylaştığı deneyimler — hiçbir değişiklik yapılmadan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {messages.map((msg) => (
            <div key={msg.id} className="bg-white rounded-2xl p-5 border border-gray-100">
              {/* WhatsApp header */}
              <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-50">
                <div className="w-10 h-10 flex items-center justify-center bg-whatsapp rounded-full flex-shrink-0">
                  <i className="ri-whatsapp-line text-white text-lg"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-brand-navy font-heading font-bold text-sm truncate">{msg.name}</div>
                  <div className="text-gray-400 text-xs truncate">{msg.location}</div>
                </div>
                <div className="text-gray-300 text-xs whitespace-nowrap">{msg.date}</div>
              </div>

              {/* Mesaj balonu */}
              <div className="bg-[#DCF8C6] rounded-xl rounded-tl-none px-4 py-3 mb-3 relative">
                <p className="text-gray-700 text-sm leading-relaxed">{msg.text}</p>
                <div className="flex items-center justify-end gap-1 mt-2">
                  <span className="text-gray-400 text-xs">{msg.time}</span>
                  <span className="w-4 h-4 flex items-center justify-center text-[#53BDEB]">
                    <i className="ri-check-double-line text-sm"></i>
                  </span>
                </div>
              </div>

              {/* Yıldızlar */}
              <div className="flex items-center gap-1">
                {Array.from({ length: msg.stars }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-brand-orange">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
                <span className="text-gray-400 text-xs ml-1">Mükemmel</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 text-sm mb-4">Siz de deneyiminizi paylaşın</p>
          <a
            href="https://wa.me/905322376576?text=Merhaba%2C%20hizmetinizden%20çok%20memnun%20kaldım!"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-line text-base"></i></span>
            Yorumunuzu Paylaşın
          </a>
        </div>
      </div>
    </section>
  );
}
